import React from "react";
import { ManageAdvisorContainer } from "../../../containers";

const ManageAdvisor = (props) => {
  return <ManageAdvisorContainer {...props} />;
};

export default ManageAdvisor;
